export enum ChartTypes {
    CATEGORIES, SECTORS, TOPICS
}